import React from 'react';
import { DragIndicator } from '@mui/icons-material';
import { WorkItem } from '../workItemTypes';
import { DragAndDropHandlers } from '../hooks/useDragAndDrop';
import { formatStatusDisplay, formatCustomerDisplay } from '../utils/workItemUtils';

export interface WorkItemRowProps {
  workItem: WorkItem;
  isSelected: boolean;
  isDragging: boolean;
  dragOverClass: string;
  onWorkItemSelect: (workItem: WorkItem) => void;
  dragHandlers: DragAndDropHandlers;
}

export const WorkItemRow: React.FC<WorkItemRowProps> = ({
  workItem,
  isSelected,
  isDragging,
  dragOverClass,
  onWorkItemSelect,
  dragHandlers
}) => {
  const handleClick = () => {
    onWorkItemSelect(workItem);
  };

  const rowClasses = [
    'workitem-row',
    isSelected ? 'selected' : '',
    isDragging ? 'dragging' : '',
    dragOverClass
  ].filter(Boolean).join(' ');



  return (
    <div
      className={rowClasses}
      onClick={handleClick}
      draggable
      onDragStart={(e) => dragHandlers.handleDragStart(e, workItem.id)}
      onDragEnd={dragHandlers.handleDragEnd}
      onDragOver={(e) => dragHandlers.handleDragOver(e, workItem.id)}
      onDrop={(e) => dragHandlers.handleDrop(e, workItem.id)}
      onDragEnter={(e) => dragHandlers.handleDragEnter(e, workItem.id)}
      onDragLeave={dragHandlers.handleDragLeave}
    >
      <div className="workitem-row-content">
        <div className="workitem-id">
          <div className="drag-handle">
            <DragIndicator style={{ fontSize: '16px', color: '#999' }} />
          </div>
          <span className="workitem-id-text">{workItem.id}</span>
        </div>
        
        <div className="workitem-title">
          <div className="workitem-title-text">{workItem.title}</div>
        </div>
        
        <div className="workitem-customer-column">
          <div className="workitem-customer-name">{formatCustomerDisplay(workItem)}</div>
        </div>
        
        <div className="workitem-status">
          <span className="status-text">
            {formatStatusDisplay(workItem.status)}
          </span>
        </div>
      </div>
    </div>
  );
};